/* assets/brand-mark.js
   Gør alle forekomster af "Lion Jewels" til versaler "LION JEWELS" og wrapper dem,
   så brandet kan styles separat via .brand-mark.
*/
(() => {
  const BRAND_TEXT = 'LION JEWELS';
  const BRAND_REGEX = /lion\s+jewels/gi;

  // Tags vi aldrig må røre
  const SKIP_TAGS = new Set([
    'SCRIPT', 'STYLE', 'NOSCRIPT', 'CODE', 'PRE',
    'TEXTAREA', 'INPUT', 'SELECT', 'IFRAME', 'SVG', 'CANVAS'
  ]);

  // Undgå at køre i Shopify Theme Editor preview-panelets chrome
  const inDesignMode = !!(window.Shopify && Shopify.designMode);

  function shouldSkipNode(node) {
    if (!node || !node.parentNode) return true;
    const p = node.parentNode;

    // spring over allerede markerede dele
    if (p.classList && p.classList.contains('brand-mark')) return true;

    // spring over "problem-tags"
    if (SKIP_TAGS.has(p.nodeName)) return true;

    // undgå contenteditable felter
    if (p.closest('[contenteditable="true"]')) return true;

    return false;
  }

  function wrapBrandInTextNode(textNode) {
    if (shouldSkipNode(textNode)) return;

    const text = textNode.nodeValue;
    if (!text || !BRAND_REGEX.test(text)) {
      // reset regex state pga. .test med /g
      BRAND_REGEX.lastIndex = 0;
      return;
    }
    BRAND_REGEX.lastIndex = 0;

    const frag = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = BRAND_REGEX.exec(text)) !== null) {
      const start = match.index;
      const end = BRAND_REGEX.lastIndex;

      // tekst før match
      if (start > lastIndex) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));
      }

      // selve brandet — altid versaler
      const span = document.createElement('span');
      span.className = 'brand-mark';
      span.textContent = BRAND_TEXT; // tving versaler
      frag.appendChild(span);

      lastIndex = end;
    }

    // rest af teksten
    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(frag, textNode);
  }

  function processTree(root) {
    if (!root || SKIP_TAGS.has(root.nodeName)) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          // kun reelle tekstnoder med potentielt match
          if (!node.nodeValue || !BRAND_REGEX.test(node.nodeValue)) {
            BRAND_REGEX.lastIndex = 0;
            return NodeFilter.FILTER_REJECT;
          }
          BRAND_REGEX.lastIndex = 0;
          return shouldSkipNode(node)
            ? NodeFilter.FILTER_REJECT
            : NodeFilter.FILTER_ACCEPT;
        }
      },
      false
    );

    const toProcess = [];
    let n;
    while ((n = walker.nextNode())) toProcess.push(n);
    toProcess.forEach(wrapBrandInTextNode);
  }

  // Opdater <title> også
  function normalizeTitle() {
    if (typeof document.title === 'string' && BRAND_REGEX.test(document.title)) {
      document.title = document.title.replace(BRAND_REGEX, BRAND_TEXT);
      BRAND_REGEX.lastIndex = 0;
    }
  }

  function init() {
    processTree(document.body);
    normalizeTitle();

    // Observer for dynamisk indhold
    const mo = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'characterData' && m.target.nodeType === Node.TEXT_NODE) {
          wrapBrandInTextNode(m.target);
        } else if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
              wrapBrandInTextNode(node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              processTree(node);
            }
          });
        }
      }
    });

    mo.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
